export const API_URL = (import.meta.env.VITE_API_URL || "http://localhost:5005").replace(/\/+$/, "");

export const PUBLIC_SITE_URL = (import.meta.env.VITE_PUBLIC_SITE_URL || "http://localhost:5006").replace(/\/+$/, "");
